import React from "react";
import cx from "classnames";

import Card from "../card";
import { useDraft } from "../useDraft";
import { canEdit } from "src/pages/experiences/storyboardSettings/utils/permissions";
import shared from "../siteSettings.module.scss";
import styles from "./siteVerificationCard.module.scss";

const SiteVerificationCard: React.FC = () => {
  const { draft, setField } = useDraft();
  const value = draft?.siteVerification?.googleVerification ?? "";
  const editable = canEdit(draft?.role);

  return (
    <Card
      title="Site Verification"
      description="To claim ownership of your site, add the provided meta tags from search engines"
    >
      <div className={styles.verificationItem}>
        <div className={shared.fieldLabel}>Google Search Console</div>
        <input
          type="text"
          className={shared.input}
          placeholder="Enter Google site verification code"
          value={value}
          disabled={!editable}
          onChange={(e) =>
            setField("siteVerification", {
              ...(draft?.siteVerification ?? {}),
              googleVerification: e.target.value,
            })
          }
        />
      </div>
      <div className={styles.helper}>
        To get a verification meta tag, go to{" "}
        {editable ? (
          <a
            className={styles.helperLink}
            href="https://search.google.com/search-console/welcome"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Search Console
          </a>
        ) : (
          <span
            className={cx(styles.helperLink, styles.disabled)}
            aria-disabled="true"
          >
            Google Search Console
          </span>
        )}
      </div>
    </Card>
  );
};

export default SiteVerificationCard;
